import { RateSheetDimension } from '@/utils/RateSheetMatching'

const DIMENSION_LABELS = {
  [RateSheetDimension.Species]: line => line.speciesGroup?.label,
  [RateSheetDimension.Length]: line => line.lengthGroup?.label,
  [RateSheetDimension.Diameter]: line => line.diameterGroup?.label,
  [RateSheetDimension.Grade]: line => line.grade?.name,
  [RateSheetDimension.EndUseSort]: line => line.endUseSort?.name
}

export function rateSheetLineLabel (line) {
  return Object.values(RateSheetDimension)
    .map(dimension => DIMENSION_LABELS[dimension](line))
    .filter(label => !!label)
    .join(' · ')
}

export function combinationLabel (combination) {
  return [
    combination.speciesName,
    `${combination.length}'`,
    `${combination.diameter}"`,
    combination.gradeName,
    combination.endUseSortName
  ].filter(part => !!part).join(' · ')
}

export function combinationKey (combination) {
  return [combination.speciesId, combination.gradeId, combination.endUseSortId ?? '_', combination.length, combination.diameter].join('|')
}
